import React from 'react';
import axios from 'axios';
import { Button, TextArea, Modal, Icon, Input } from 'semantic-ui-react';
import ReactGA from 'react-ga';
import Completion from './Completion';
import FishermanLogo from './FishermanLogo';
import { getBusinessEmailServiceURL } from '../../../utils/urls';

export default class RequestEditModal extends React.Component {
  constructor() {
    super();
    this.state = {
      currentRequestMessage: '',
      requestInProgress: true,
      name: '',
      email: '',
      phone: '',
      errorMessage: '',
    };
    this.handleRequestChange = this.handleRequestChange.bind(this);
    this.submitRequest = this.submitRequest.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.clickToPublish = this.clickToPublish.bind(this);
    this.setErrorMessage = this.setErrorMessage.bind(this);
  }

  setErrorMessage(message, stop = false) {
    this.setState({ errorMessage: message });

    if (!stop) {
      setTimeout(() => this.setErrorMessage('', true), 3000);
    }
  }

  validateInput() {
    const { name, email, phone } = this.state;

    if (name.length === 0) return 'Please enter your name';
    if (email.length === 0) return 'Please enter your email';
    if (phone.length === 0) return 'Please enter your phone number';
    return true;
  }

  handleFieldChange(e, { value, name }) {
    this.setState({ [name]: value });
  }

  handleRequestChange(e, { value }) {
    this.setState({ currentRequestMessage: value });
  }

  submitRequest() {
    const { currentRequestMessage, email, phone, name: personalName } = this.state;
    const validation = this.validateInput();

    if (validation === true) {
      const { business } = this.props;
      const { type: businessType, id: businessId } = business;

      const url = getBusinessEmailServiceURL(businessType, businessId);

      axios
        .post(url, {
          contact_name: personalName,
          contact_email: email,
          contact_phone: phone,
          message: currentRequestMessage,
          email_type: 'publish_banner_request_edit',
        })
        .then(() => {
          this.setState({ requestInProgress: false });
        });
    } else {
      this.setErrorMessage(validation);
    }
  }

  clickToPublish() {
    const { handlePublishOpen, handleRequestEditClose } = this.props;
    handlePublishOpen();
    handleRequestEditClose();
  }

  logEvent(step) {
    const { business } = this.props;

    ReactGA.event({
      category: 'Checkout',
      action: `Step ${step}`,
      label: business.name,
    });
  }

  renderRequestEdit() {
    const { handleRequestEditClose } = this.props;
    const { email, name, phone, errorMessage } = this.state;
    this.logEvent('Request Edit');

    return (
      <React.Fragment>
        <Modal.Header className="modal-header">Request an edit</Modal.Header>
        <div className="modal-content modal-body">
          <span className="body-text blue-color">
            Let us know if you have a specific request for an update to this website and we’ll
            respond within 48 hours. Note that once you publish your site, you can easily edit
            content, color, and font directly using the Fisherman Dashboard. &nbsp;
            <Button
              id="publish-now-from-request-button"
              className="publish-now-from-request-button body-text blue-color"
              onClick={this.clickToPublish}
            >
              Click here
            </Button>
            &nbsp;to publish now.
          </span>
          <h3 className="header-text blue-color extra-margin">Describe your request here</h3>
          <div className="request-edit-fields">
            <Input value={name} placeholder="Name" name="name" onChange={this.handleFieldChange} />
            <Input
              value={email}
              placeholder="Email"
              name="email"
              onChange={this.handleFieldChange}
            />
            <Input
              value={phone}
              placeholder="Phone"
              name="phone"
              onChange={this.handleFieldChange}
            />
          </div>
          <TextArea
            id="request-text-area"
            type="text"
            placeholder="Edit Request"
            className="request-input"
            onChange={this.handleRequestChange}
          />
          {errorMessage && <div style={{ color: 'red', textAlign: 'center' }}>{errorMessage}</div>}
          <div className="centered-content extra-margin">
            <Button
              id="back-button-request-edit"
              className="back-edit-request-button blue-color body-text"
              onClick={handleRequestEditClose}
            >
              Back
            </Button>
            <Button
              id="submit-edit-request-button"
              className="submit-edit-request-button body-text green-background-color"
              onClick={() => this.submitRequest()}
            >
              Submit
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderCompletion() {
    this.logEvent('Request Edit Completion');

    return (
      <Completion
        title="Submission Complete"
        description="We will text you a link to your edited site within 48 hours."
      />
    );
  }

  render() {
    const { requestInProgress } = this.state;
    const { showRequestEditModal, handleRequestOpen, handleRequestClose } = this.props;
    const modalBody = requestInProgress ? this.renderRequestEdit() : this.renderCompletion();

    return (
      <Modal
        id="request-edit-modal"
        trigger={
          <Button id="request-edit-button" className="payment-request-button">
            Request an edit
          </Button>
        }
        className="modal-container"
        dimmer="inverted"
        open={showRequestEditModal}
        onOpen={handleRequestOpen}
        onClose={handleRequestClose}
        closeIcon={
          <Button id="inside-close-icon" className="inside-close-icon" icon>
            <Icon name="close" />
          </Button>
        }
      >
        <FishermanLogo />
        {modalBody}
      </Modal>
    );
  }
}
